import type { PlatformTermsContent } from '../constants/platformTermsContent';
import styles from './PlatformTermsBody.module.css';

type PlatformTermsBodyProps = {
  content: PlatformTermsContent;
  showHeading?: boolean;
  className?: string;
};

export function PlatformTermsBody({
  content,
  showHeading = false,
  className,
}: PlatformTermsBodyProps) {
  return (
    <div className={className ? `${styles.root} ${className}` : styles.root}>
      {showHeading ? <h4 className={styles.heading}>{content.heading}</h4> : null}
      <p className={styles.intro}>{content.intro}</p>
      <div className={styles.sections}>
        {content.sections.map((section) => (
          <section key={section.title} className={styles.section}>
            <h5 className={styles.sectionTitle}>{section.title}</h5>
            <p className={styles.sectionBody}>{section.body}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
